<!-- @ts-ignore -->
<script lang="ts" setup>
  import { type Component, computed } from 'vue'
  import { ToIcon } from '@/plugins/IconPlugin.ts'

  interface Props {
    icon?: AllIconsType | Component
    class?: CssClassType
    size?: number
  }

  const props = defineProps<Props>()
  const { icon, size } = toRefs(props)
  const iconComp = computed(() => ToIcon(icon.value))

  const sizeClass = computed<string>(() => {
    if (size.value) return `size-${size.value}`
    else return 'size-4'
  })
</script>

<template>
  <component
    :is="iconComp"
    v-if="iconComp"
    aria-hidden="true"
    :class="[props.class, 'p-inputicon', sizeClass]" />
</template>
